import React, { startTransition } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ADVANCED_AMENITY_OPTIONS } from "../homeShared";

export default function AdvancedSearchInline({
  draftZip,
  setDraftZip,
  draftRadius,
  setDraftRadius,
  draftFeatures,
  setDraftFeatures,
  onApply,
  applyDisabled,
  onClose,
}) {
  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        maxWidth: 768,
        mx: "auto",
        mt: 2.2,
        p: { xs: 1.75, sm: 2.25 },
        borderRadius: "10px",
        bgcolor: "#ffffff",
        border: "1px solid #dfe5ee",
        textAlign: "left",
        "& .MuiFormControlLabel-label": { textAlign: "left" },
      }}
    >
      <Stack spacing={1.7}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={{ fontWeight: 700, fontSize: 22, color: "#22374a" }}>
            Advanced Filters
          </Typography>
          <IconButton
            aria-label="Close advanced filters"
            size="small"
            onClick={onClose}
            sx={{ color: "#7f8da1" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#33475b", mb: 0.6 }}>
              zip code
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Enter zip code"
              value={draftZip}
              onChange={(event) => setDraftZip(event.target.value)}
              inputProps={{ inputMode: "numeric", maxLength: 10 }}
              sx={{
                "& .MuiOutlinedInput-root": { height: 42, bgcolor: "#fff" },
                "& .MuiOutlinedInput-input": { fontSize: 14 },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#33475b", mb: 0.6 }}>
              Search Radius
            </Typography>
            <FormControl size="small" fullWidth>
              <Select
                value={String(draftRadius || 10)}
                onChange={(event) => setDraftRadius(Number(event.target.value || 10))}
                inputProps={{ "aria-label": "Select search radius" }}
                sx={{ height: 42, bgcolor: "#fff", fontSize: 14 }}
              >
                <MenuItem value="5">5 miles</MenuItem>
                <MenuItem value="10">10 miles</MenuItem>
                <MenuItem value="15">15 miles</MenuItem>
                <MenuItem value="25">25 miles</MenuItem>
                <MenuItem value="50">50 miles</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#33475b", mb: 0.6 }}>
              Gender Preference
            </Typography>
            <FormControl size="small" fullWidth>
              <Select
                value={draftFeatures.gender || "Any"}
                onChange={(event) =>
                  setDraftFeatures((features) => ({ ...features, gender: event.target.value }))
                }
                inputProps={{ "aria-label": "Select gender" }}
                sx={{ height: 42, bgcolor: "#fff", fontSize: 14 }}
              >
                <MenuItem value="Any">Any</MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} />

          <Grid item xs={12}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#33475b", mb: 0.7 }}>
              Amenities
            </Typography>
            <Grid container spacing={0.25}>
              {ADVANCED_AMENITY_OPTIONS.map(([key, label]) => (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={!!draftFeatures[key]}
                        onChange={(event) =>
                          setDraftFeatures((features) => ({
                            ...features,
                            [key]: event.target.checked,
                          }))
                        }
                        sx={{ p: 0.5, color: "#bcc8d8" }}
                      />
                    }
                    label={<Typography sx={{ fontSize: 13, color: "#4a5b70" }}>{label}</Typography>}
                    sx={{ m: 0 }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={() => startTransition(() => onApply())}
            disabled={applyDisabled}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              px: 2.2,
              py: 0.9,
              borderRadius: "8px",
              bgcolor: "#22374a",
              "&:hover": { bgcolor: "#1c3042" },
            }}
          >
            Apply Filters
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
